import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { ActionMenu, ActionMenuProps } from '@lyearn/molecules';
import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';
import { QuestionEditor } from '@/modules/corporate/modules/scorecards/components/Question';
import { QuestionFormActions } from '@/modules/corporate/modules/scorecards/views/ScorecardCreator/interfaces';

import { questionItemStyles } from './styles';
import { QuestionItemProps } from './types';
import { getActionMenuItems } from './utils';

const OVERRIDES: ActionMenuProps['overrides'] = {
  PopoverContent: { minWidth: 16, position: 'bottom-start' },
};

function QuestionItem({ error, question, onAction, onChange }: QuestionItemProps) {
  const { t } = useTranslation();

  const onItemClick = useCallback(
    (action: string) => {
      onAction(action as QuestionFormActions);
    },
    [onAction],
  );

  return (
    <Box className={cn('relative pt-24', questionItemStyles)}>
      <QuestionEditor error={error} question={question} onChange={onChange} />
      <Box className="action-menu-btn absolute top-0 end-0">
        <ActionMenu items={getActionMenuItems(t)} overrides={OVERRIDES} onAction={onItemClick} />
      </Box>
    </Box>
  );
}

export default QuestionItem;
